export const PRE_CUSTOMER = {
  PRELOAD: {
    first_name: 'Lorem',
    middle_name: 'Ipsum',
    first_surname: 'Lorem',
    second_surname: 'Ipsum',
    identification_number: '12345678',
    identification_expedition_at: '2022-09-20',
    occupation: 'Dependiente',
    email: 'email@email.com',
    email_confirmation: 'email@email.com',
    civil_status: 'single',
    accept_processing_of_personal_data: true,
    accept_processing_of_personal_data_at: '2022-09-20T10:49:10Z',
    accept_personal_data_for_commercial_purposes: true,
    accept_personal_data_for_commercial_purposes_at: '2022-09-20T10:49:10Z',
  },
  PRECUSTOMER: {
    phone_number: '999999999',
  },
};
